export default "assets/images/bg_cream-7dbd8cd4.png";